export const ACTIVITY_TYPES = [
  { value: 1, label: "Bluetooth Adapter" },
  { value: 2, label: "Bluetooth Scan" },
  { value: 3, label: "Bluetooth Connection" },
  { value: 4, label: "Firmware Version" },
  { value: 5, label: "Event" },
  { value: 6, label: "Mode" },
  { value: 7, label: "Battery" },
  { value: 8, label: "Set Date Time" },
  { value: 9, label: "Online" },
  { value: 10, label: "Offline" },
  { value: 11, label: "Clear Watch Data" },
  { value: 12, label: "Check Offline Data" },
  { value: 13, label: "Upload Data Sync" },
  { value: 14, label: "Login" },
  { value: 15, label: "Logout" },
  { value: 16, label: "Out Of Range" },
  { value: 17, label: "Survey" },
  { value: 18, label: "Socket" },
];
